import axios from "axios";
import config from "./../config";

export default {
  async login(username, password) {
    return await axios.post(`${config.endpoint}/auth/login`, {
      username,
      password
    });
  },
  async logout(token) {
    if (token)
      return await axios.post(`${config.endpoint}/auth/logout`, { token });
    else return false; // Несмотря на то, что токена нет - результат операции выполнения запроса - отрицательный
  }
};
